module.exports = {
  // For integration and staging calls to APIs uses self-signed certificates.
  // This options avoids rejecting unauthorized certificates.
  // NOTE: It never must be acive in production.
  NODE_TLS_REJECT_UNAUTHORIZED: true,

  // Suffix to apply to the domains.
  // Depending on the environment the domain can be:
  // - development: casas.trovit.com.pa.local
  // - integration: casas.trovit.es.int01.devel
  // - production: casas.trovit.es (has no suffix)
  trovit_suffix: '',

  appEnvironment: 'production',

  // Application log messages
  logger: {
    // Use levels compatible with syslog. Possible values are:
    // debug, info, notice, warning, error, crit, alert, emerg
    level: 'info',

    console: {
      colorize: true,
    },

    // file: {
    //   filename: './log/integration.log',
    //   maxsize: 5242880, // 5MB
    //   maxFiles: 5,
    // },

    // syslog: {
    //   ref: 'syslog_server',
    // },
  },

  // Syslog server
  syslog_server: {
    host: 'syslog.services',
    port: 10270,
    app_name: 'web-pwa-production',
  },

  // StatsD
  statsd: {
    host: 'statsd-proxy.sysops.svc.cluster.local',
    port: 8125,
    prefix: 'web.pwa.prod',
  },

  // Redis AB tests
  redisAbTest: {
    port: 6379,
    host: 'web-redis-slave.service.prod.bcn.trovit',
    hashName: 'ab_test',
    retryTime: 10 * 1000, // 10 secs
    maxAttempts: 10,
    maxTotalRetyTime: 60 * 60 * 1000, // 1 hour
    readTimeout: 200, // 200 ms
  },

  // Redis Publish your cv (Partners)
  redisPublishYourCv: {
    port: 6379,
    host: 'web-redis-slave.service.prod.bcn.trovit',
    hashName: '',
    retryTime: 10 * 1000, // 10 secs
    maxAttempts: 10,
    maxTotalRetyTime: 60 * 60 * 1000, // 1 hour
    readTimeout: 300, // ms
  },

  // Segmentation API endpoint (there's is only one server -production-)
  segmentationApi: 'http://user-api.service.prod.bcn.trovit',
};



// WEBPACK FOOTER //
// ./parameters/server/config.js